var _defs, _path, _rect, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _rect2, _line, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStyle801(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-212,.cls-211,.cls-209{fill:#fff;}.cls-212,.cls-211,.cls-210,.cls-209{stroke:#000;stroke-miterlimit:10;}.cls-212{stroke-width:3px;}.cls-210{fill:none;}.cls-209{stroke-width:1.98px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M96.44,407.71l41.21,7.39a69.58,69.58,0,0,1,25.1,9.8l48.75,31c1.25-41.42-3.18-92.73,0-124.93,7.06-71.4-.53-147.62-1.42-219.45-4.32.47-23.4,2.08-39.57-11.1A51,51,0,0,1,156,81.15l-44.86,23.79-2,1.08h-.06l-.27.14v1.67q.93,2.64,1.72,5.42c8.68,30.12,7.16,70.74.81,75.71a17.56,17.56,0,0,1-7.45,3.67,44.26,44.26,0,0,1-5.25.76h-.26l-1.39.12c.59,2.23,1.15,4.49,1.66,6.79q1.86,8.37,3.15,17.37c2.48,17.22,3.59,36.29,4.36,57.52C108.26,335,105.61,373.4,96.44,407.71Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 110.62,
    y: 313.82,
    width: 56.76,
    height: 4.41
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M167,68.45a10.59,10.59,0,0,0-1.19,5c.2,9.6,15.13,18.82,36.67,23.78.19,4.56.69,10.11.89,14.67-2.85-.78-25.42-.36-35.17-12.69-1.75-2.21-5.25-4.88-7.56-8.58-1.16-1.87-4.69-4.77-4.39-9,.33-4.48,4.35-8,5.42-9.26A18.85,18.85,0,0,1,167,68.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M242.05,68.45a10.59,10.59,0,0,1,1.19,5C243,83,228.1,92.23,206.57,97.19c-.19,4.56-.69,10.11-.89,14.67,2.85-.78,25.42-.36,35.17-12.69,1.75-2.21,5.25-4.88,7.55-8.58,1.17-1.87,4.7-4.77,4.4-9-.33-4.48-4.35-8-5.42-9.26A18.72,18.72,0,0,0,242.05,68.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M314.53,416.77l-13.21.09c-38-49.64-93.1-78.75-157.36-77.19.9-68,4.91-144.42,0-218.67,4.32.47,67.67,1.41,96.5-20.55A51,51,0,0,0,255,81.15l44.86,23.79,2.05,1.08H302l.27.14v1.67c-.62,1.76-1.19,3.56-1.71,5.42-8.68,30.12-7.17,70.74-.81,75.71a17.56,17.56,0,0,0,7.45,3.67,44,44,0,0,0,5.25.76h.26l1.39.12q-.88,3.35-1.66,6.79-1.86,8.37-3.15,17.37c-2.48,17.22-3.59,36.29-4.36,57.52C302.71,335,305.36,382.46,314.53,416.77Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 313.82,
    r: 5.66
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 268.28,
    r: 5.66
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 131.65,
    r: 5.66
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 177.19,
    r: 5.66
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.55,
    cy: 222.73,
    r: 5.66
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 241.9,
    y: 313,
    width: 56.76,
    height: 4.41
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-210",
    x1: 261.22,
    y1: 232.28,
    x2: 259.33,
    y2: 313
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "275.38 173.83 232.95 173.83 236.25 163.5 278.68 163.5 275.38 173.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle801);
export default __webpack_public_path__ + "static/media/STYLE 8-01.585c0f2fd6a439e3fb19f6349f504e53.svg";
export { ForwardRef as ReactComponent };